import jsPDF from "jspdf";

export function downloadPDF(data) {
  const doc = new jsPDF();

  // Header
  doc.setFontSize(18);
  doc.text("💰 Salary Slip", 20, 20);

  doc.setFontSize(11);
  doc.text("Generated Salary Statement", 20, 28);

  // Line separator
  doc.line(20, 32, 190, 32);

  // Content (IMPORTANT FIX: use INR instead of ₹)
  doc.setFontSize(12);

  doc.text(`Gross Salary: INR ${data.salary}`, 20, 45);
  doc.text(`Tax Deducted: INR ${data.tax}`, 20, 55);
  doc.text(`Net Salary: INR ${data.net}`, 20, 65);

  // Optional extra info
  doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 20, 80);

  // Footer
  doc.line(20, 85, 190, 85);
  doc.setFontSize(10);
  doc.text("This is a system generated salary slip.", 20, 95);

  doc.save("salary-slip.pdf");
}